const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedAffiliateLevel: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const affiliatelevel = (state = initialState, action) => {
	switch (action.type) {
		case 'AFFILIATELEVEL_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'AFFILIATELEVEL_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'AFFILIATELEVEL_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'AFFILIATELEVEL_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'AFFILIATELEVEL_GET_CURRENT':
			return {
				...state,
				selectedAffiliateLevel: action.selectedAffiliateLevel,
			}
		case 'AFFILIATELEVEL_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default affiliatelevel
